import React from "react";
import { Link } from "react-router-dom";
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import Button from "../../../components/CustomButtons/Button";
import Footer from "../../../components/Footer/Footer";

import SponsorsCarouselSection from "./SponsorsCarouselSection";

import footerStyle from "../../../assets/jss/material-kit-pro-react/views/componentsSections/footerStyle";

function FooterSection({ ...props }) {
    const { classes } = props;
    return (
        <div>
            <Footer
                theme="dark"
                content={
                    <div>
                        <div className={classes.left}>
                            <List className={classes.list}>
                                <ListItem className={classes.inlineBlock}>
                                    <Link to="/accommodations" className={classes.block}>Alojamientos</Link>
                                </ListItem>
                                <ListItem className={classes.inlineBlock}>
                                    <Link to="/tours" className={classes.block}>Tours</Link>
                                </ListItem>
                                <ListItem className={classes.inlineBlock}>
                                    <Link to="/terminos-y-condiciones" className={classes.block}>Condiciones</Link>
                                </ListItem>
                                <ListItem className={classes.inlineBlock}>
                                    <Link to="/quienes-somos" className={classes.block}>La Empresa</Link>
                                </ListItem>
                                <ListItem className={classes.inlineBlock}>
                                    <Link to="/contacto" className={classes.block}>Contacto</Link>
                                </ListItem>
                            </List>
                        </div>
                        <div className={classes.right}>
                            &copy; {1900 + new Date().getYear()}{" "}
                            Vivamos el Campo.{" "}
                            Todos los derechos reservados.
                        </div>
                    </div>
                }
            >
                <GridContainer>
                    {/*Social and Contact info*/}
                    <GridItem xs={12} sm={12} md={4} lg={4}>
                        <h4>Síguenos en</h4>
                        <ul className={classes.socialButtons}>
                            <li>
                                <a href="https://www.facebook.com/vivamoselcampo/" target="_blank" rel="noopener noreferrer">
                                    <Button justIcon simple color="facebook">
                                        <i className="fab fa-facebook-square" />
                                    </Button>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.instagram.com/vivamoselcampo/" target="_blank" rel="noopener noreferrer">
                                    <Button justIcon simple color="instagram">
                                        <i className="fab fa-instagram" />
                                    </Button>
                                </a>
                            </li>
                            <li>
                                <a href="https://twitter.com/vivamoselcampo" target="_blank" rel="noopener noreferrer">
                                    <Button justIcon simple color="twitter">
                                        <i className="fab fa-twitter" />
                                    </Button>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.youtube.com/channel/UCUvSqN1FljzYH4MQpfQ1fzw" target="_blank" rel="noopener noreferrer">
                                    <Button justIcon simple color="youtube">
                                        <i className="fab fa-youtube" />
                                    </Button>
                                </a>
                            </li>
                        </ul>
                        <h4>Contacto</h4>
                        <h5>
                            <i className="fas fa-phone" /> {' '} 315 795 1330 - 313 208 9988
                        </h5>
                        <h5>
                            <i className="fas fa-envelope" /> {' '} vivamoselcampo@gmail.com
                        </h5>
                        <h5>
                            <i className="fas fa-map-marker-alt" /> {' '} Cra 7 #1B-36, barrio La Florida, Tunja, Boyacá
                        </h5>
                    </GridItem>
                    {/*End Social and Contact info*/}
                    {/*Links to sections*/}
                    <GridItem xs={6} sm={6} md={2} lg={2}>
                        <h4>Explora</h4>
                        <ul className={classes.linksVertical}>
                            <li>
                                <Link to="/accommodations">Alojamientos</Link>
                            </li>
                            <li>
                                <Link to="/tours">Tours</Link>
                            </li>
                            {/*<li>
                                <Link to="/blog">Blog</Link>
                            </li>*/}
                            <li>
                                <Link to="/contenido-360">Contenido 360</Link>
                            </li>
                        </ul>
                    </GridItem>
                    <GridItem xs={6} sm={6} md={2} lg={2}>
                        <h4>Usuarios</h4>
                        <ul className={classes.linksVertical}>
                            <li>
                                <Link to="/login">Iniciar sesión</Link>
                            </li>
                            <li>
                                <Link to="/signup">Registrarse</Link>
                            </li>
                        </ul>
                        <br/>

                        <h4>Legal</h4>
                        <ul className={classes.linksVertical}>
                            <li>
                                <Link to="/terminos-y-condiciones">Términos y Condiciones</Link>
                            </li>
                        </ul>
                    </GridItem>
                    {/*End Links to sections*/}

                    {/*Sponsors Carousel*/}
                    <GridItem xs={12} sm={12} md={4} lg={4}>
                        <h4>Contamos con el apoyo de</h4>
                        <SponsorsCarouselSection />
                    </GridItem>
                    {/*End Sponsors Carousel*/}
                </GridContainer>
            </Footer>
        </div>
    )
}

export default withStyles(footerStyle)(FooterSection);


// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/FooterSection.jsx